import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export type City = ApiSchemas['CityPresenter']

export default {
  async get(id: number) {
    return wrapEndpoint(() =>
      client.GET('/city/{id}', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
  async getByCep(cep: string) {
    return wrapEndpoint(() =>
      client.GET('/city/by-cep/{cep}', {
        params: {
          path: {
            cep,
          },
        },
      }),
    )
  },
  async list(options?: ApiSchemas['ListCityDto']) {
    return wrapEndpoint(() =>
      client.GET('/city', {
        params: {
          query: options,
        },
      }),
    )
  },
}
